import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useIsSmallScreen } from '@/hooks/useIsSamllScreen'
import type { Game } from '@/redux/reducers/gameReducer'
import YeekeeLottoCard from '@/ui-components/components/YeekeeLottoCard'
import { getLottoNameAndCountryFromLottoGame } from '@/utils/lotto-type-v2'
import { getBackgroundFlagGroup } from '@/utils/flag-utils'
import { getResultNumber } from './result-card.utils'
import { trans } from '@/i18n/utils'

export const YeekeeLottoResultCard = ({
  game,
  rounds,
}: {
  game: Game
  rounds: Game['rounds']
}) => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const isSmallScreen = useIsSmallScreen(768 - 1) // 768px breakpoint for small screens

  const { country, name: flagBackgroundName } =
    getLottoNameAndCountryFromLottoGame(game.type, game.flag)
  const title = trans(i18n, game.translations, 'name')

  const processedRounds = rounds.map((round) => ({
    round: t(
      isSmallScreen
        ? 'lottoPage.lottoRound.round_name_short'
        : 'lottoPage.lottoRound.round_name',
      {
        round: round.round_number,
        name: title,
      },
    ),
    threeTop: getResultNumber(round.top_three_result),
    twoUnder: getResultNumber(round.bottom_two_result),
    onClick: () => {
      navigate(`/lotto/${game.code}/${game.id}/${round.id}`)
    },
  }))

  return (
    <YeekeeLottoCard
      key={`yeekee-${game.id}`}
      country={country}
      flagBackgroundName={getBackgroundFlagGroup(flagBackgroundName)}
      title={title}
      rounds={processedRounds}
    />
  )
}
